import axios from 'axios';
import Cache from './../frame/Cache';
import Config from './../config/Config';

export default class Axios {
    static ajax(options, props) {
        const access = sessionStorage.getItem("_user_access_");

        let headers = {};

        headers = { 'Content-Type': 'application/json;charset=utf-8' };
       
        if (access !== undefined && access !== null) 
        {
            headers["Authorization"] = "Access " + access;
        }

        axios({
            method: 'post',
            url: options.url,
            crossDomain: true,
            data: options.params,
            headers: headers,
        }).then(function (response) {

            if (props && response.data.status == 10 || response.data.message == '缺少认证信息!' || response.data.message == '没有访问权限') 
            {
                Cache.logout(props);
            }

            if( response.data.status===10 || response.data.message == '缺少认证信息!' || response.data.message == '没有访问权限') 
            {
                window.location = window.location.origin + Config.getBaseRoutePath() + '/login';
                return false
            }

            if (options.callback !== undefined) 
            {
                options.callback.call(this, response.data, options.params, options.backParam);
            }

        }).catch(function (error) {
            console.error(error);
        });
    }

    static ajaxFile(options) {
        const access = sessionStorage.getItem("_user_access_");

        let headers = {};

        headers = { 'Content-Type': 'application/json;charset=utf-8' };

        if (access !== undefined && access !== null) {
            headers["Authorization"] = "Access " + access;
        }

        axios({
            method: 'get',
            url: options.url,
            crossDomain: true,
            headers: headers,
        }).then(function (response) {

            if (options.callback !== undefined) {
                options.callback.call(this, response.data);
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    /**
     * 上传文件
     * @param {s} options {FormData }
     */
    static uploadFile(options) {
        const access = sessionStorage.getItem("_user_access_");

        let headers = {};

        headers = { 'Content-Type': 'multipart/form-data' };

        if (access !== undefined && access !== null) {
            headers["Authorization"] = "Access " + access;
        }

        axios({
            method: 'post',
            url: options.url,
            crossDomain: true,
            data: options.formData,
            headers: headers
        }).then(function (response) {

            if (options.callback !== undefined) {
                options.callback.call(this, response.data, options.backParam);
            }

        }).catch(function (error) {
            console.log(error);
        });
    }

    static downloadFile(options, props)
    {
        const access = sessionStorage.getItem("_user_access_");

        let headers = {};

        headers = {'Content-Type':'application/json;charset=utf-8'};

        if( access!==undefined && access!==null )
        {
            headers["Authorization"] = "Access " + access;
        }
        
        axios({
            method:'post',
            url : options.url,
            crossDomain:true,
            data : options.params,
            headers: headers,
            responseType: 'arraybuffer'
        }).then( function( response ) {

            if( props!==undefined && response.data.status===10  )
            {
                Cache.logout(props);
            }

            if( options.callback!==undefined )
            {
                options.callback.call( this, response.data, options.params, options.backParam );
            }

        }).catch( function( error ) {
            console.error( error);
        });
    }


    static exportFile(options) {
        const access = sessionStorage.getItem("_user_access_");

        let headers = {};

        headers = { 'Content-Type': 'application/json;charset=utf-8' };

        if (access !== undefined && access !== null) {
            headers["Authorization"] = "Access " + access;
        }

        axios({
            method: 'post',
            url: options.url,
            crossDomain: true,
            data: options.params,
            headers: headers,
            responseType: 'blob'
        }).then(function (response) {
            let url = window.URL.createObjectURL(response.data);
            let eleLink = document.createElement('a');
            eleLink.href = url;

            let fileName = "export.xlsx";

            if (options.params !== undefined && options.params.fileName !== undefined) {
                fileName = options.params.fileName;
            }

            eleLink.download = fileName;
            document.body.appendChild(eleLink);
            eleLink.click();
            window.URL.revokeObjectURL(url);

        }).catch(function (error) {
            console.log(error);
        });
    }

    static getExportFile(options) {
        const access = sessionStorage.getItem("_user_access_");

        let headers = {};

        headers = { 'Content-Type': 'application/json;charset=utf-8' };

        if (access !== undefined && access !== null) {
            headers["Authorization"] = "Access " + access;
        }

        axios({
            method: 'get',
            url: options.url,
            crossDomain: true,
            data: options.params,
            headers: headers,
            responseType: 'blob'
        }).then(function (response) {
            let url = window.URL.createObjectURL(response.data);
            let eleLink = document.createElement('a');
            eleLink.href = url;

            let fileName = "export.pdf";

            if (options.params !== undefined && options.params.fileName !== undefined) {
                fileName = options.params.fileName;
            }

            eleLink.download = fileName;
            document.body.appendChild(eleLink);
            eleLink.click();
            window.URL.revokeObjectURL(url);

        }).catch(function (error) {
            console.log(error);
        });
    }


    
    static ajaxGet(options, props) {

        let headers = {};

        if( options.access )
        {
            const access = sessionStorage.getItem("_user_access_");

            headers = { 'Content-Type': 'application/json;charset=utf-8' };
           
            if (access !== undefined && access !== null) 
            {
                headers["Authorization"] = "Access " + access;
            }
        }

        axios({
            method: 'get',
            url: options.url,
            crossDomain: true,
            data: options.params,
            headers: headers,
        }).then(function (response) {

            // if (props && response.data.status == 10 || response.data.message == '缺少认证信息!' || response.data.message == '没有访问权限') 
            // {
            //     Cache.logout(props);
            // }

            // if (response.data.status == 10 || response.data.message == '缺少认证信息!' || response.data.message == '没有访问权限') 
            // {
            //     window.location = window.location.origin + ''
            //     return false
            // }

            if (options.callback !== undefined) 
            {
                options.callback.call(this, response.data, options.params, options.backParam);
            }

        }).catch(function (error) {
            console.error(error);
        });
    }
  
}